import { render, staticRenderFns } from "./AchievementPopup.vue?vue&type=template&id=71a0efa2&scoped=true"
import script from "./AchievementPopup.vue?vue&type=script&lang=js"
export * from "./AchievementPopup.vue?vue&type=script&lang=js"
import style0 from "./AchievementPopup.vue?vue&type=style&index=0&id=71a0efa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a0efa2",
  null
  
)

export default component.exports